/**
 * Number of cards shown on initial render for every tab.
 * Always fixed at 12 regardless of total count.
 */
export const INITIAL_PAGE_SIZE = 12

/**
 * Tabs with fewer cards than this threshold show all cards immediately
 * without a "Show more" button, to avoid unnecessary interaction for small sets.
 */
export const SHOW_ALL_THRESHOLD = 48

/**
 * Maximum number of "Show more" clicks a user should need to reveal all cards.
 * Together with SHOW_ALL_THRESHOLD this drives the step size calculation.
 */
export const MAX_CLICKS = 4
